<template>
  <div class="course-creater-header-step">
    <el-steps :active="active" finish-status="success" align-center>
      <el-step title="课题名称"></el-step>
      <el-step title="筛选课题数据"></el-step>
      <el-step title="完成创建课题"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    active: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
.course-creater-header-step {
  width: 600px;
  padding-top: 5px;
  position: relative;
  left: -48px;
}
</style>
